import { render, staticRenderFns } from "./view_ProductPage.vue?vue&type=template&id=66e35520&scoped=true&"
import script from "./view_ProductPage.vue?vue&type=script&lang=js&"
export * from "./view_ProductPage.vue?vue&type=script&lang=js&"
import style0 from "./view_ProductPage.vue?vue&type=style&index=0&id=66e35520&prod&lang=css&"
import style1 from "./view_ProductPage.vue?vue&type=style&index=1&id=66e35520&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e35520",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
